const LEAD_NEGATIVE_OUTCOMES = [
  'not interested',
  'fake',
  'invalid phone number',
  'phone number belongs to another user',
  'already solved',
  'does not requirements',
];

export default LEAD_NEGATIVE_OUTCOMES;
